import React from "react";

import useTheme from "./hooks/useTheme";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TalentMore from "./components/TalentMore";
import Suhavi from "./components/Suhavi";
import VideoProfiles from "./components/VideoProfiles";
import ChoosePath from "./components/ChoosePath";
import Jobs from "./components/Jobs";
import HowItWorks from "./components/HowItWorks";
import Diversity from "./components/Diversity";
import Resources from "./components/Resources";
import Testimonials from "./components/Testimonials";
import EmployerSection from "./components/EmployerSection";
import Newsletter from "./components/Newsletter";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

// Preview of the redesigned home page, served at /home-v2. Ships its own
// navbar/footer (see HomeV2Layout) and brand tokens scoped under .home-v2
// (see _homeV2.scss) so it can't affect the live "/" home page.
const HomeV2 = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="home-v2" data-theme={theme}>
      <Navbar theme={theme} onToggleTheme={toggleTheme} />
      <Hero />
      <TalentMore />
      <Suhavi />
      <VideoProfiles />
      <ChoosePath />
      <Jobs />
      <HowItWorks />
      <Diversity />
      <Resources />
      <Testimonials />
      <EmployerSection />
      <Newsletter />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default HomeV2;
